import { render } from "./ShiftsComponent.vue?vue&type=template&id=6977ea92&scoped=true"
import script from "./ShiftsComponent.vue?vue&type=script&lang=js"
export * from "./ShiftsComponent.vue?vue&type=script&lang=js"

import "./ShiftsComponent.vue?vue&type=style&index=0&id=6977ea92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6977ea92"]])

export default __exports__